import { DATA_IN_INTEGRATION_DEFINITIONS } from '@/lib/integrations/catalog/data_in'

export function FramerFormGuide() {
  return (
    <section
      className="flex flex-col gap-5"
      aria-labelledby="framer-setup-heading"
    >
      <h2 id="framer-setup-heading" className="font-medium text-lg">
        Set up your Framer form
      </h2>
      <ol className="flex list-decimal flex-col gap-4 pl-5 text-sm">
        {DATA_IN_INTEGRATION_DEFINITIONS.framer.tutorialSteps.map((step) => (
          <li key={step.label} className="pl-1">
            <span className="font-medium">{step.label}</span>
            <p className="mt-1 text-muted-foreground">{step.description}</p>
          </li>
        ))}
      </ol>
      <p className="text-muted-foreground text-sm">
        After the test, open Contacts to inspect the saved email and fields. The
        Submissions tab shows receipt, contact ingestion, and automation
        dispatch separately.
      </p>
      <FramerFormHelp />
      <a
        className="text-sm underline underline-offset-4"
        href="https://www.framer.com/help/articles/framer-form-webhook-setup/"
        target="_blank"
        rel="noreferrer"
      >
        Framer webhook documentation
      </a>
    </section>
  )
}

export function FramerFormHelp() {
  return (
    <details className="border-t pt-4 text-sm">
      <summary className="cursor-pointer text-muted-foreground transition-colors hover:text-foreground">
        Troubleshooting
      </summary>
      <dl className="mt-4 grid gap-4">
        <div>
          <dt className="font-medium">Field mismatch</dt>
          <dd className="text-muted-foreground">
            Input names are case sensitive. Use email, not Email. Undeclared
            scalar fields are ignored and appear as warnings. Dates stay text;
            nested fields, arrays, and uploads are unsupported.
          </dd>
        </div>
        <div>
          <dt className="font-medium">Signing failure</dt>
          <dd className="text-muted-foreground">
            Copy the current URL and secret into the native webhook settings.
            Publish after changing settings. Regenerating a secret invalidates
            the previous one immediately.
          </dd>
        </div>
        <div>
          <dt className="font-medium">Throttling or temporary failure</dt>
          <dd className="text-muted-foreground">
            New submissions are limited to 120 per minute per form and 600 per
            minute per brand. Framer retries non-2xx responses up to five times
            and does not follow redirects. These are form and brand limits, not
            visitor limits.
          </dd>
        </div>
        <div>
          <dt className="font-medium">No automation runs</dt>
          <dd className="text-muted-foreground">
            Contacts are saved without an automation. Create and publish an
            automation using this form’s trigger for future submissions.
            Framer-marked spam is discarded.
          </dd>
        </div>
      </dl>
    </details>
  )
}
